<!-- 学校-课程考勤统计 -->
<template>
  <div class="container">
    <div class="index" v-show="!detail.show">
      <div class="title">
        <span>{{$route.name}}</span>
        <p style="color:#606266;font-size:14px;">截止日期: {{dayjs().format('YYYY-MM-DD')}}</p>
      </div>

      <!-- <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程出勤率前五名</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程出勤率后五名</span>
          </div>
          <div id="echarts-box2"></div>
        </div>
      </header> -->

      <div class="query">
        <el-form ref="form" :model="queryParams" label-width="90px"> </el-form>
        <div class="query">
          <el-form ref="form" :inline="true" :model="queryParams" label-width="90px">
            <el-form-item label="">
              <el-select
                v-model="queryParams.semester"
                placeholder="请选择学年学期"
              >
                <el-option
                  v-for="item in semesterList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="">
              <el-input
                v-model="queryParams.name"
                clearable
                placeholder="请输入课程名称"
              />
            </el-form-item>
            <!-- <el-form-item label="">
              <el-date-picker
                style="width:275px"
                v-model="queryParams.selectData"
                :picker-options="pickerOptions"
                type="week"
                :format="queryParams.startDate + '到' + queryParams.endDate + '第 WW 周'"
                placeholder="选择周"
                @change="customTimeSure"
                clearable
              >
              </el-date-picker>
            </el-form-item> -->
            <el-form-item label="">
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table ref="multipleTable" :data="tableData" style="width: 100%">
          <el-table-column align="center" prop="courseName" label="课程名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" prop="classNum" label="总课时数">
          </el-table-column>
          <el-table-column align="center" prop="unitName" label="课程来源">
          </el-table-column>
          <el-table-column align="center" prop="needAttendanceNum" label="应出勤人次" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" prop="attendanceNum" label="实际出勤人次" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" prop="attendanceRate" label="出勤率" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="toDetail(scope.row)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <Detail :info="detail.info" v-show="detail.show" @to-index="toIndex" :semester="detail_semester" :semesterList="semesterList"></Detail>
  </div>
</template>

<script>
import dayjs from "dayjs";
import api from "@/api/wisdomSchool/index";
import * as echarts from "echarts";
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  data() {
    return {
      queryParams: {
        semester: "",
        name: "",
        startDate: "",
        endDate: "",
        selectData:'',
      },
      semesterList: [],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      pageNum: 1,
      pageSize: 10,
      totalPage: 10,
      info: "", // 出库单页面参数
      tableData: [],
      currentPage: 4,
      detail: {
        info: {},
        show: false,
      },
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // },
      },
      detail_semester:'',
    };
  },
  mounted() {
    // this.init();
  },
  created() {
    if(this.semesterArr && this.semesterArr.length>0){
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
        isCurrent: v.isCurrent,
      }));
      this.queryParams.semester = this.semesterList.filter(e=>e.isCurrent)[0]?.value;
    }
    this.getDataList();
  },
  methods: {
    dayjs,
    async getDataList() {
      let params = {
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        schoolYearSemester: this.queryParams.semester,
        courseName: this.queryParams.name,
        teacherId: '',
        startDate: this.queryParams.startDate,
        endDate: this.queryParams.endDate,
        page: this.pageNum,
        limit: this.pageSize,
      };
      var { data, code } = await api.teacherCourseAttendance(params);
      if (code == "0") {
        this.tableData = data.list;
        this.totalPage = data.total;
        this.detail_semester = this.queryParams.semester;
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    // 自定义时间过滤
    customTimeSure() {
      let that = this.queryParams;
      if (that.selectData) {
        that.startDate = dayjs(that.selectData)
          .startOf("week")
          .format("YYYY-MM-DD");
        that.endDate = dayjs(that.selectData)
          .endOf("week")
          .format("YYYY-MM-DD");
      }
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init(){
      let vm = this;
      this.$nextTick(() => {
        // 柱状图
        let chartDom1 = document.getElementById('echarts-box1');
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['作业\n辅导', '作业\n辅导', '科技\n编程', '作业\n辅导', '作业\n辅导'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [95, 92, 87, 76, 70],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
                
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart1.setOption(option1);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box2');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['博学\n书法', '世界\n百科课', '美学\n鉴赏课', '竞技\n篮球', '温暖\n美术'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [79, 76, 70, 65, 55],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#51D6A6' },
                  ]),
                  label: {
                    formatter: "{c}%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);
      });
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner{
  /* width: 275px; */
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0px 30px 30px 30px;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}

header{
    width: 100%;
    height: 350px;
    display: flex;
    .header-item{
      width: 50%;
      .header-item-title{
        font-size: 18px;
        color: #333;
        display: flex;
        align-items: center;
        .circle{
          width: 8px;
          height: 8px;
          display: inline-block;
          background: #4991e1;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .header-item-text{
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box1, #echarts-box2{
      width:90%;
      height:280px;
    }
}
</style>
